import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { SlideLayout, ViewMode } from '@gripp/shared-ui';
import { Tags as TagsOld } from './tags-old';
import { TagsColumns } from './tagsColumns';

export const Tags = () => {
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  if (isCropCircleRedesignEnabled) {
    return (
      <SlideLayout 
        columns={TagsColumns}
        viewMode={ViewMode.SINGLE}
      />
    );
  }

  return <TagsOld />;
};
